
import { ServiceCategory } from '@/types/serviceTypes';
import { lawnGardenCategory } from './services/lawnGardenServices';
import { landscapeDesignCategory } from './services/landscapeDesignServices';
import { hardscapingCategory } from './services/hardscapingServices';
import { specialtyServicesCategory } from './services/specialtyServices';

export const serviceCategories: ServiceCategory[] = [
  lawnGardenCategory,
  landscapeDesignCategory,
  hardscapingCategory,
  specialtyServicesCategory
];
